import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaTimes,
  FaBook,
  FaCode,
  FaFileAlt,
  FaUser,
  FaSitemap,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TypingEffect from "../../HomePage/VideoComponent/TypingEffect";
import "./MobileNavbar.css";

const MobileNavbar = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger the opening animation after component mount
    setTimeout(() => {
      setIsOpen(true);
    }, 50);
  }, []);

  const isActive = (path) => {
    // Never return active-link for home page
    if (location.pathname === "/") {
      return "inactive-link";
    }
    // For other pages
    return location.pathname === path ? "active-link" : "inactive-link";
  };

  const scrollToFooter = () => {
    navigate("/");
    setTimeout(() => {
      const footerElement = document.getElementById("footer");
      if (footerElement) {
        footerElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      onClose();
    }, 800);
  };

  const menuItems = [
    { icon: <FaBook />, text: "אודות", link: "/about" },
    { icon: <FaCode />, text: "פתרונות LeetCode", link: "/VlogListLeetCode" },
    {
      icon: <FaSitemap />,
      text: "ארכיטקטורת קוד",
      link: "/VlogListCodeArchitecture",
    },
    { icon: <FaFileAlt />, text: "וולוגים", link: "/VlogListAllVlogs" },
    {
      icon: <FaUser />,
      text: "איפה עוד אפשר למצוא אותי?",
      link: "/",
      onClick: scrollToFooter,
    },
  ];

  return (
    <div className={`mobile-menu ${isOpen ? "visible" : ""}`}>
      <motion.button
        className="menu-button"
        onClick={handleClose}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <FaTimes />
      </motion.button>

      <div
        className="website-name"
        onClick={() => {
          navigate("/");
          handleClose();
        }}
        style={{ cursor: "pointer" }}
      >
        <TypingEffect text="פינתי" />
      </div>

      {menuItems.map((item, index) => (
        <div
          key={item.text}
          className={`menu-item ${isActive(item.link)}`}
          onClick={() => {
            if (item.onClick) {
              item.onClick();
            }
            handleClose();
          }}
        >
          <Link to={item.link} className="mobile-link">
            {item.icon}
            {item.text}
          </Link>
        </div>
      ))}

      {/* Hidden navigation button to Tech Series page (larger and positioned after menu items) */}
      <button
        style={{
          width: "50px",
          height: "30px",
          opacity: 0,
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          marginTop: "10px",
        }}
        aria-hidden="true"
        onClick={() => {
          navigate("/VlogListTechSeries");
          handleClose();
        }}
      >
        Tech Series
      </button>
    </div>
  );
};

export default MobileNavbar;
